import React, {useContext, useState} from 'react'
import PropTypes from "prop-types";
import OfferPositionForm from "./components/OfferPositionForm";
import scrollTo from "libs/scrollTo";
import {connect} from "react-redux";
import {OfferMode} from "../../../../common/constants/OfferMode";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Tr from "translations/Translations";
import {RoundType} from "constants/RoundType";
import {makeStyles} from "@material-ui/styles";
import {simpleConfirm} from "libs/ConfirmNotification";
import SupportModeContext from "context/SupportModeContext";
import PurchaserOfferContext from "context/PurchaserOfferContext";

const useStyle = makeStyles(theme => ({
    title: {
        top: 105,
        zIndex: theme.zIndex.appBar - 2,
        position: "sticky",
        background: theme.palette.background.default,
        borderRadius: theme.spacing(1.5, 1.5, 0, 0),
        padding: theme.spacing(2, 0, 2, 0),
        border: `solid 1px ${theme.palette.border.dark}`,
        borderBottom: "none"
    },
    content: {
        border: `solid 1px ${theme.palette.border.dark}`,
        padding: theme.spacing(2),
        borderTop: "none",
        marginTop: 0,
        borderRadius: theme.spacing(0, 0, 1.5, 1.5),
    }
}))

function OfferSinglePosition(
    {
        position,
        positionsLoaded,
        mode,
        formValues,
        formSubmit,
        disabled,
        roundType,
        offerEdit,
    }) {
    const classes = useStyle();
    const FORM_ID = "offerPositionForm_" + position.positionId
    const [working, setWorking] = useState(false);
    const supportMode = useContext(SupportModeContext);
    const purchaserOfferContext = useContext(PurchaserOfferContext);

    const getButtons = () => {
        const buttons = [];
        if (formValues[FORM_ID + "_dirty"]) {
            buttons.push(createButton(Tr('discard_changes'), () => simpleConfirm("discard_changes_confirm", formSubmit[FORM_ID + "_reset"]), "outlined", working))
        }
        if (!offerEdit.disabled) {
            buttons.push(createButton(Tr('save'), (e) => {
                e.stopPropagation();
                formSubmit[FORM_ID]()

                setTimeout((formId) => scrollTo("#" + formId + " .MuiFormHelperText-root.Mui-error", 210), 100, FORM_ID);
            }, undefined, working || (!formValues[FORM_ID + "_dirty"] && positionsLoaded[DemandOffersOfferService.getLoadedPositionKey(position.positionId)]?.status !== 'PLACED_OUT_OF_DATE') || supportMode || purchaserOfferContext?.preview, undefined, working))
        }
        return buttons;
    }

    return (<>
        <MultiButton className={classes.title} buttons={getButtons()}/>
        <div className={classes.content}>
            <OfferPositionForm
                expanded
                setExpanded={() => false}
                working={working}
                setWorking={setWorking}
                position={position}
                loadedPosition={positionsLoaded[DemandOffersOfferService.getLoadedPositionKey(position.positionId)]}
                formId={FORM_ID}
                mode={mode}
                roundType={roundType}
                offerEdit={offerEdit}
                disabled={disabled}
            />
        </div>
    </>)

}

OfferSinglePosition.propTypes = {
    positionsLoaded: PropTypes.object.isRequired,
    mode: PropTypes.oneOf(Object.keys(OfferMode)).isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
};

export default connect((state) => ({
    formValues: state.formValues,
    formSubmit: state.form,
}), {})(OfferSinglePosition);